<template>
  <div>
    <div class="page-download">
      <button class="btn btn-danger btn-block btn-lg" @click="rdr_back" type="button">
        Back
      </button>
      <a href="javascript:window.print()" class="btn btn-info btn-block btn-lg" type="button"><i class="fa fa-print"></i>
        Cetak</a>
    </div>

    <div id="page-wrap">
      <div class="logo-header">
        <img src="@/assets/images/invoice-logo.png" />

        <div class="right-company">
          <template v-if="data.store !== undefined">
            <span> {{ data.store.str_name }} </span>
            <p>{{ data.store.str_address }}, {{ data.store.str_phone }}</p>
          </template>
        </div>
      </div>
      <div id="header"><b>SLIP GAJI</b></div>
      <div id="customer">
        <div id="customer-title">
          <span> Nama Karyawan : {{ data.emp_name }} </span>
        </div>
        <table id="meta" class="table-bordered">
          <tr>
            <td class="meta-head">Periode #</td>
            <td>
              <span>{{ data.payroll.periode }}</span>
            </td>
          </tr>
          <tr>
            <td class="meta-head">Tanggal</td>
            <td>
              <span id="date">{{ data.payroll.date }}</span>
            </td>
          </tr>
          <tr>
            <td class="meta-head">Status</td>
            <td>
              <span id="date">{{ data.payroll.status }}</span>
            </td>
          </tr>
        </table>
      </div>
      <br>
      <div class="row" style="margin-top: 0px; !important">
        <div class="column">
          <table id="items">
            <tr class="border_bottom">
              <th colspan="2" style="width: 50%;"><b>Pendapatan</b></th>
            </tr>
            <tr>
              <td>1. Gaji Pokok</td>
              <td width="20%">Rp. {{ numberWithCommas(data.payroll.gaji) }}</td>
            </tr>
            <tr>
              <td>2. Lemburan</td>
              <td width="20%">Rp. {{ numberWithCommas(data.payroll.total_lembur) }}</td>
            </tr>
            <tr>
              <td>3. Insentif</td>
              <td width="20%">Rp. {{ numberWithCommas(data.payroll.total_insentif) }}</td>
            </tr>
          </table>
        </div>
        <div class="column">
          <table id="items">
            <tr class="border_bottom">
              <th colspan="2" style="width: 50%;"><b>Potongan</b></th>
            </tr>
            <template v-if="data.payroll.potongan">
              <tr v-for="(tj, k) in data.payroll.potongan" :key="k">
                <template v-if="tj.value != 0">
                  <td>{{ tj.name }}</td>
                  <td width="20%">Rp. {{ numberWithCommas(tj.value) }}</td>
                </template>
              </tr>
            </template>
            <template v-else>
              <tr class="border_bottom">
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <table id="items">
            <thead>
              <tr>
                <th colspan="2" style="width: 50%;">Tunjangan</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tj, k) in data.payroll.tunjangan" :key="k">
                <template v-if="tj.value != 0">
                  <td>{{ tj.name }}</td>
                  <td width="20%">Rp. {{ numberWithCommas(tj.value) }}</td>
                </template>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>4. Total Tunjangan</td>
                <td width="20%">Rp. {{ numberWithCommas(data.payroll.total_tunjangan) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="column" style="border-bottom: 1px solid black;">
          <table id="items" style="border-bottom: none !important;">
            <thead>
              <tr>
                <th>Catatan</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="border-bottom: none !important;">{{ data.payroll.note != null ? data.payroll.note : "" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
      <table class="items" style="width: 100%;">
        <thead>
          <tr>
            <th style="text-align: center;">Total Gaji : Rp. {{ numberWithCommas(data.payroll.total_gaji) }}</th>
          </tr>
        </thead>
      </table>
      <table id="ttd">
        <tr>
          <td>
            <p>Karyawan</p>
          </td>
          <td>
            <p>Pemilik</p>
          </td>
        </tr>
        <tr style="height: 30px">
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <p>{{ data.emp_name }}</p>
          </td>
          <td>
            <p><b>Rasim Rusdianto</b></p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: "Payroll",
      table_module: "payroll",
      alias_table: "payroll",
      data: {},
      error: {},
      uuid: this.$route.params.uuid,
      periode: this.$route.params.periode,
      detailBulk: [],
      detailService: [],
      detailProducts: [],
    };
  },
  computed: {
    filename() {
      var date = this.data.srv_t_code;
      return date;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(this.table_module + "/edit/" + this.periode + '/' + this.uuid)
        .then((response) => {
          this.data = response.data.data;
        });
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    rdr_back() {
      this.$router.push({ name: this.table_module });
    },
  },
};
</script>


<style scoped>
.border_bottom {
  border-top: 2px solid black;
  border-bottom: 2px solid black;
}

@media print {
  .page-download {
    display: none;
  }
}

* {
  margin: 0;
  padding: 0;
}

body {
  font: 14px/1.4 Georgia, serif;
}

#page-wrap {
  width: 100%;
  margin: 0;
  font-weight: bold;
  font-size: 16px;
}

.page-download {
  width: 300px;
  margin-bottom: 20px;
  margin-left: 0px;
}

textarea {
  border: 0;
  font: 14px Georgia, Serif;
  overflow: hidden;
  resize: none;
}

table {
  border-collapse: collapse;
}

table td,
table th {
  border: 1px solid black;
  padding: 5px;
}

#header {
  width: 100%;
  margin: 0px 10px 20px 0;
  text-align: center;
  font: bold 19px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}

.cetak {
  width: 100%;
  margin: 0px 10px 20px 0;
  background: #222;
  text-align: center;
  color: white;
  font: bold 15px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}

#address {
  width: 250px;
  height: 150px;
  float: left;
}

#customer {
  overflow: hidden;
}

#logo {
  text-align: right;
  float: right;
  position: relative;
  margin-top: 25px;
  border: 1px solid #fff;
  max-width: 540px;
  max-height: 100px;
  overflow: hidden;
}

#logo:hover,
#logo.edit {
  border: 1px solid #000;
  margin-top: 0px;
  max-height: 125px;
}

#logoctr {
  display: none;
}

#logo:hover #logoctr,
#logo.edit #logoctr {
  display: block;
  text-align: right;
  line-height: 25px;
  background: #eee;
  padding: 0 5px;
}

#logohelp {
  text-align: left;
  display: none;
  font-style: italic;
  padding: 10px 5px;
}

#logohelp input {
  margin-bottom: 5px;
}

.edit #logohelp {
  display: block;
}

.edit #save-logo,
.edit #cancel-logo {
  display: inline;
}

.edit #image,
#save-logo,
#cancel-logo,
.edit #change-logo,
.edit #delete-logo {
  display: none;
}

#customer-title {
  float: left;
}

#customer-title span {
  font-size: 16px;
  font-weight: bold;
}

#customer-title p {
  font-size: 14px;
}

#meta {
  margin-top: 1px;
  width: 300px;
  float: right;
}

#meta td {
  text-align: right;
}

#meta td.meta-head {
  text-align: left;
  background: #eee;
}

#meta td textarea {
  width: 100%;
  height: 20px;
  text-align: right;
}

#items {
  clear: both;
  width: 100%;
  margin: 0;
  border: 1px solid black;
}

#items th {
  background: #eee;
}

#items textarea {
  width: 80px;
  height: 50px;
}

#items tr.item-row td {
  vertical-align: top;
}

#items td.description {
  width: 450px;
}

#items td.item-name {
  width: 175px;
}

#items td.description textarea,
#items td.item-name textarea {
  width: 100%;
}

#items td.total-line {
  border-right: 0;
  text-align: right;
}

#items td.total-value {
  border-left: 0;
  padding: 10px;
}

#items td.total-value textarea {
  height: 20px;
  background: none;
}

#items td.balance {
  background: #eee;
  font: bold 13px Helvetica, Sans-Serif;
}

#items td.blank {
  border: 0;
}

#terms {
  /* text-align: center; */
  margin: 0px 0 0 0;
}

#terms h5 {
  text-transform: uppercase;
  font: 13px Helvetica, Sans-Serif;
  letter-spacing: 10px;
  border-bottom: 1px solid black;
  padding: 0 0 8px 0;
  margin: 0 0 8px 0;
}

#terms textarea {
  width: 100%;
  text-align: center;
}

textarea:hover,
textarea:focus,
#items td.total-value textarea:hover,
#items td.total-value textarea:focus,
.delete:hover {
  background-color: #eeff88;
}

.delete-wpr {
  position: relative;
}

.delete {
  display: block;
  color: #000;
  text-decoration: none;
  position: absolute;
  background: #eeeeee;
  font-weight: bold;
  padding: 0px 3px;
  border: 1px solid;
  top: -6px;
  left: -22px;
  font-family: Verdana;
  font-size: 12px;
}

#ttd {
  clear: both;
  width: 100%;
  margin: 60px 0 0 0;
  border: 0px solid black;
  text-align: center;
}

#ttd td,
#ttd th {
  border: 0px solid black !important;
  padding: 5px;
}

.logo-header {
  display: block;
  margin-bottom: 0px;
  height: 70px;
}

.logo-header img {
  height: 100px;
  margin-bottom: 0px;
  /* margin-left: -20px; */
}

.right-company {
  float: right;
  margin-top: 10px;
  text-align: right;
}

.right-company span {
  font-weight: bold;
  font-size: 19px;
}

#items td.price {
  width: 175px;
}

* {
  box-sizing: border-box;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 50%;
  border-right: 1px solid black;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>
